import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { updateMetaTags } from '../utils/seo';
import Translate from '../components/Translate';
import PageBanner from '../components/PageBanner';

const AccessibilityStatement = () => {
    const { t, i18n } = useTranslation();

    useEffect(() => {
        updateMetaTags(
            `${t('accessibility_statement')} | ${t('site-title')}`,
            t('accessibility_statement_desc'),
            "accessibility, wcag 2.0, inclusive web, employment news"
        );
    }, [t, i18n.language]);

    return (
        <section className="w-full min-h-screen bg-primary-50/30 pb-16 text-left">
            <PageBanner
                title={<Translate text={'accessibility_statement'} />}
                subtitle={<Translate text={'accessibility_statement-subtitle'} />}
                badgeText={t('badge-accessibility-support')}
            />
            <div className="max-w-5xl mx-auto px-4 py-12 sm:px-6 lg:px-8 mt-12">
                <div className="bg-white rounded-[24px] shadow-sm border border-[#dadce0] overflow-hidden">
                    <div className="p-8 lg:p-12 space-y-8">
                        <section className="prose prose-blue max-w-none">
                            <p className="text-lg text-gray-800 leading-relaxed font-semibold">
                                {t('acc-statement-p1')}
                            </p>
                            <p className="text-gray-600 leading-relaxed mt-4">
                                {t('acc-statement-p2')}
                            </p>
                        </section>

                        <div className="p-6 bg-primary-50/30 rounded-2xl border border-primary-100">
                            <h3 className="text-lg font-bold text-primary-800 mb-2">{t('acc-standards-title')}</h3>
                            <p className="text-gray-700 text-sm leading-relaxed">
                                {t('acc-standards-desc')}
                            </p>
                        </div>

                    </div>
                </div>
            </div>
        </section>
    );
};

export default AccessibilityStatement;
